import common from "../common";
import Scene from "./Scene";
import Button from "../ui/Button";

export default class IntroScene extends Scene 
{
    constructor(flipBoards)
    {
        super('intro');
        this.flipBoards = flipBoards;
        this.introAdded = false;
        this.flipBoardImages = ['world_united', '1goal', '0emissions'];
        this.currentBoard = 0;
    }

    init()
    {
        super.init(); 
        
        if(common.basicMode || !this.flipBoards)
        {
            this.addIntroPanel();
            this.signals.setMusic.dispatch('music_splash_loop_00');
        }
    }

    update(dt)
    {
        super.update(dt);

        if(this.flipBoards && !common.basicMode && common.introVideoFinished && !this.introAdded)
        {
            this.introAdded = true;
            MEDIATOR.pcApp.appStarted();

            this.boardsFlipped();

            /*
            common.boardGraphicGenerator.getPixelsFromImage(common.baseUrl + 'assets/images/boards/world_united.png', (pixelData) => {
                MEDIATOR.pcApp.setBoardImage(common.boardGraphicGenerator.restrictColours(pixelData, common.boardGraphicGenerator.textRestrictedColours));
                
                setTimeout(() => {
                    common.boardGraphicGenerator.getPixelsFromImage(common.baseUrl + 'assets/images/boards/1goal.png', (pixelData) => {
                        MEDIATOR.pcApp.setBoardImage(common.boardGraphicGenerator.restrictColours(pixelData, common.boardGraphicGenerator.textRestrictedColours));

                        setTimeout(() => {
                            common.boardGraphicGenerator.getPixelsFromImage(common.baseUrl + 'assets/images/boards/0emissions.png', (pixelData) => {
                                MEDIATOR.pcApp.setBoardImage(common.boardGraphicGenerator.restrictColours(pixelData, common.boardGraphicGenerator.textRestrictedColours));
                            });
                        }, 4000);
                    });
                }, 4000);
            });*/
            //if(!common.soundManager.audioBlocked)
            //{
                common.soundManager.play('sfx_crowd_ambient_loop_01');
                this.signals.setMusic.dispatch('music_splash_loop_00');
            //}
        }
    }

    postInit()
    {
        super.postInit();
    }

    addIntroPanel()
    {
        this.addPanel();

        this.panel.addClass('p3-panelIntro');

        var title = $('<div class="p3-panelItem p3-lightText">' + common.config.strings.intro_title[common.country].toUpperCase() + '</div>');
        this.panelInner.append(title);

        var logo = $('<div class="p3-panelItem"><img src="' + common.baseUrl + '/assets/images/ui_logo_world_united.png" style="height:10vh" /></div>');
        this.panelInner.append(logo);

        var fontSize = 2.5;
        var flashComp = true;
        for(var i in common.config.questions)
        {
            if(common.config.questions[i].id == "flash" && common.config.questions[i].disabled == true)
            {
                fontSize = 2.9;
                flashComp = false;
            }
        }


        var text = $('<div class="p3-panelItem" style="font-size:' + fontSize + 'vh; color:#000000">' + common.config.strings.intro[common.country] + '</div>');
        this.panelInner.append(text);
        
        if(common.config.settings.compEnabled)
        {
            text = $('<div class="p3-panelItem" style="font-size:' + fontSize + 'vh; color:#000000">' + common.config.strings.prize_intro[common.country] + '<br /><span class="p3-boldText">' + common.config.strings.prize[common.country] + '</span></div>');
            this.panelInner.append(text);
        }
        else if(!flashComp)
        {
            text = $('<div class="p3-panelItem" style="font-size:' + fontSize + 'vh; color:#000000">' + common.config.strings.no_comp[common.country] + '</div>');
            this.panelInner.append(text);
        }
        
        if(flashComp)
        {
            var text = $('<div class="p3-panelItem" style="font-size:3.5vh;">' + common.config.strings.question_flash_title[common.country] + '<br /><span class="p3-boldText">' + common.config.strings.question_flashCode[common.country] + '</span></div>');
            this.panelInner.append(text);
        }

        var submit = this.addSubmitButton(common.config.strings.start_button[common.country]);
        this.signalListeners.push(submit.signals.up.add(() => 
        {
            this.animatePanelOut(() => {
                console.log('animatePanelOut');
                this.signals.next.dispatch();
            });
            if(common.soundManager.audioBlocked)
            {
                common.soundManager.play('sfx_crowd_ambient_loop_01');
            }
            common.soundManager.play('music_sting_wooh_00');
        }));
        this.buttons['submit'] = submit;

        if(common.config.settings.compEnabled || flashComp)
        {
            this.panelFooter.append(submit.htmlElement);
        }
    }

    boardsFlipped()
    {
        if(this.currentBoard >= this.flipBoardImages.length)
        {
            setTimeout(() => {
                MEDIATOR.beginApp();
            }, 1000);
        }
        else
        {
            common.boardGraphicGenerator.getPixelsFromImage(common.baseUrl + 'assets/images/boards/' + this.flipBoardImages[this.currentBoard] + '.png', (pixelData) => {
                MEDIATOR.pcApp.setBoardImage(common.boardGraphicGenerator.restrictColours(pixelData, common.boardGraphicGenerator.textRestrictedColours));
            });
            this.currentBoard++;
        }
    }
}